import jsPDF from "jspdf";
import getImgDataURL from "@/helpers/getImgDataURL";
import generateRoutePdfTitle from "@/helpers/generateRoutePdfTitle";
import generateMapRouteDataURL from "@/helpers/generateMapRouteDataURL";
import generateRouteCoordinatesListTable from "@/helpers/generateRouteCoordinatesListTable";
import addHtmlToJsPDF from "@/helpers/addHtmlToJsPDF";
import generateRoutePdfFooter from "@/helpers/generateRoutePdfFooter";
import cssVariables from "@/config/cssVariables"
import { i18n } from "@/plugins/i18n"

export default async function generateRoutePdf(route) {
  /**
   * @type {jsPDF}
   */
  let doc = jsPDF();

  // Head logo
  const {
    dataUrl: logoDataUrl,
    imageWidth: logoWidth,
    imageHeight: logoHeight
  } = getImgDataURL('.logo__image', 1, 2)
  const logoImageHeight = 22
  const logoImageWidth = (logoImageHeight * logoWidth) / logoHeight
  doc.addImage(logoDataUrl, 'PNG', 10, 10, logoImageWidth, logoImageHeight)

  // Head title
  doc.setFontSize(50)
  doc.setTextColor(cssVariables["app-primary-color"])
  doc.text(i18n.t('routePDF.title').toLocaleUpperCase(), 200, 27, {
    align: "right"
  })

  // Head bottom line
  doc.line(10, 35, 200, 35);

  // Content background heraldry
  const {
    dataUrl: heraldryDataUrl,
    imageWidth: heraldryWidth,
    imageHeight: heraldryHeight
  } = getImgDataURL('.timeline__background-image', .05)
  const heraldryImageWidth = 70
  const heraldryImageHeight = (heraldryImageWidth * heraldryHeight) / heraldryWidth
  doc.addImage(heraldryDataUrl, 'PNG', 70, 190, heraldryImageWidth, heraldryImageHeight)

  // Content title
  const titleLabel = route.label
  const { el:  title, height: titleHeight } = generateRoutePdfTitle(titleLabel)
  const docTitleHeight = Math.ceil(titleHeight * (190 / 719))
  doc = await addHtmlToJsPDF(doc, title, {
    x: 10,
    y: 38,
    width: 190,
    windowWidth: 719,
    html2canvas: {
      backgroundColor: null
    }
  })

  const hasDescription = !!route.description

  // Content map
  const imageWidth = hasDescription ? 105 : 190
  const imageHeight = 110

  const mapWidth = hasDescription ? 450 : 810
  const mapHeight = (imageHeight * mapWidth) / imageWidth

  const mapRouteDataURL = await generateMapRouteDataURL(route, mapWidth, mapHeight, 2)
  doc.addImage(mapRouteDataURL, 'PNG',  10, 44 + docTitleHeight, imageWidth, imageHeight)

  if (hasDescription) {
    // Content description background
    doc.setFillColor('#eee')
    doc.rect(120, 44 + docTitleHeight, 80, 110, 'F')

    // Content description
    const description = route.description
    doc.setFontSize(12)
    doc.text(description, 125, 52 + docTitleHeight, {
      maxWidth: 70
    })
  }

  // Content table
  const table = generateRouteCoordinatesListTable(route)
  doc = await addHtmlToJsPDF(doc, table, {
    x: 10,
    y: 161 + docTitleHeight,
    width: 180,
    windowWidth: 660,
    html2canvas: {
      backgroundColor: null
    }
  })

  // Footer top border
  const footer = generateRoutePdfFooter()
  doc = await addHtmlToJsPDF(doc, footer, {
    x: 10,
    y: 280,
    width: 180,
    windowWidth: 660
  })

  doc.save(`${ route.label }.pdf`)

  return doc
}
